module.exports = __webpack_public_path__ + "img/ieShop_logo_white.ac86cf5a.png";